import constants from "./constants";
import numbro from "numbro";
let conversionFormulas = constants.unitConversions();

const convertedValue = (value, formatterMeta) => {
  if (formatterMeta.formatter === "rssi_lookup_formatter") {
    return get_rssi_lookup_value(value);
  }
  let formatedValue = eval(formatterMeta.formula.replace(/X/g, value));
  return numbro(formatedValue).format({
    thousandSeparated: true,
    mantissa: 2,
  });
};

const undefinedFormatter = (value, formatterMeta, fallbackUnits) => {
  if (!fallbackUnits) {
    return numbro(value).format({
      thousandSeparated: true,
      mantissa: 2,
    });
  }
  return (
    numbro(value).format({
      thousandSeparated: true,
      mantissa: 2,
    }) +
    " " +
    fallbackUnits
  );
};

const get_rssi_lookup_value = (value) => {
  const lookup = {
    31: -51,
    30: -50.5,
    29: -52.0, // interpolation
    28: -53.5, // interpolation
    27: -55.5,
    26: -58, // interpolation
    25: -59.25, // interpolation
    24: -60.5,
    23: -63, // interpolation
    22: -65.5,
    21: -67, // interpolation
    20: -68.5, // interpolation
    19: -70.5,
    18: -73, // interpolation
    17: -75.5,
    16: -77, // interpolation
    15: -78.5, // interpolation
    14: -80.5,
    13: -83, // interpolation
    12: -85.5,
    11: -88, // interpolation
    10: -90.5,
    9: -92, // interpolation
    8: -93.5, // interpolation
    7: -95.5,
    6: -97, // interpolation
    5: -98.5, // interpolation
    4: -100.5,
    3: -103, // interpolation
    2: -105.5,
    1: -107, // interpolation
    0: -110.5,
  };
  return lookup[Number(value).toFixed(0)];
};

const rssi_lookup_formatter = (value, formatterMeta, fallbackUnits) => {
  return (
    numbro(get_rssi_lookup_value(value)).format({
      mantissa: 2,
      thousandSeparated: true,
    }) +
    " " +
    formatterMeta.unit
  );
};

const simpleFormatter = (value, formatterMeta, fallbackUnits) => {
  let format =
    formatterMeta.id !== "integer"
      ? {
          thousandSeparated: true,
        }
      : {
          thousandSeparated: true,
          mantissa: 1,
        };

  if (formatterMeta.unit === "") {
    return numbro(convertedValue(value, formatterMeta)).format(format);
  }

  return (
    numbro(convertedValue(value, formatterMeta)).format(format) +
    " " +
    formatterMeta.unit
  );
};

const isoprefixFormatter = (value, formatterMeta, fallbackUnits) => {
  let prefixes = ["μ", "m", "", "k", "M", "G", "T"],
    multifier = [1e-6, 1e-3, 1, 1e3, 1e6, 1e9, 1e12],
    number = Math.floor(Math.log(value) / Math.log(1000)) + 2;
  number = Math.min(Math.max(number, 0), prefixes.length - 1);
  number = value >= 0 ? number : 2;

  return (
    numbro(value / multifier[number]).format({
      mantissa: 2,
      thousandSeparated: true,
    }) +
    " " +
    prefixes[number] +
    formatterMeta.unit
  );
};

const boolFormatter = (value, formatterMeta, fallbackUnits) => {
  return Number(value) <= 0.1
    ? formatterMeta.unit.false
    : formatterMeta.unit.true;
};

const imperialLengthFormatter = (value, formatterMeta, fallbackUnits) => {
  value = convertedValue(value, formatterMeta);
  let miles = value / 5280;
  if (miles > 1) {
    return (
      numbro(miles).format({
        mantissa: 2,
        thousandSeparated: true,
      }) + " mi"
    );
  }
  return (
    numbro(value).format({
      mantissa: 2,
      thousandSeparated: true,
    }) +
    " " +
    formatterMeta.unit
  );
};

const timeFormatter = (value, formatterMeta, fallbackUnits) => {
  return (
    numbro(value).format({
      thousandSeparated: true,
      mantissa: 2,
    }) +
    " " +
    formatterMeta.unit
  );
};

const getFormatterFn = (formatterEnum) => {
  let formatters = {
    bool_formatter: boolFormatter,
    imperial_length_formatter: imperialLengthFormatter,
    isoprefix_formatter: isoprefixFormatter,
    simple_formatter: simpleFormatter,
    date_formatter: undefinedFormatter,
    datetime_formatter: undefinedFormatter,
    time_formatter: timeFormatter,
    latitude_formatter: undefinedFormatter,
    longitude_formatter: undefinedFormatter,
    rssi_lookup_formatter: rssi_lookup_formatter,
  };

  return formatters[formatterEnum] || undefinedFormatter;
};

const getConvertedValue = (
  value,
  measureType,
  unitPreference,
  overridenDisplayUnit,
  sensor
) => {
  // Do not use this for direct display to user, but just for hidden from users, like charts!
  // e.g. If will return 1.0 or 0.0 for boolean stuff instead of Off, On
  // Returns a number, not a string
  if (value === null) {
    return null;
  }

  if (
    !(measureType in conversionFormulas) ||
    measureType === "unknown" ||
    measureType === null
  ) {
    return numbro(value).format({
      thousandSeparated: true,
      mantissa: 2,
    });
  }

  let formattingDataKey =
    unitPreference === "METRIC" ? "default_metric" : "default_imperial";
  let formatterMeta;

  if (overridenDisplayUnit) {
    try {
      formatterMeta = conversionFormulas[measureType].transformations.filter(
        (transformation) => transformation.id === overridenDisplayUnit
      )[0];
    } catch (error) {
      return numbro(value).format({
        thousandSeparated: true,
        mantissa: 2,
      });
    }
  }

  if (!formatterMeta) {
    try {
      let formatterMetaId = conversionFormulas[measureType][formattingDataKey];
      formatterMeta = conversionFormulas[measureType].transformations.filter(
        (transformation) => transformation.id === formatterMetaId
      )[0];
    } catch (error) {
      return numbro(value).format({
        thousandSeparated: true,
        mantissa: 2,
      });
    }
  }

  return convertedValue(value, formatterMeta);
};

const format = (
  value,
  measureType,
  unitPreference,
  fallbackUnits,
  overridenDisplayUnit,
  alreadyConverted
) => {
  // Returns a formatted string with correct unit conversion
  if (value === null) {
    return "No data";
  }
  if (
    measureType in conversionFormulas &&
    measureType !== "unknown" &&
    measureType !== null
  ) {
    let formattingDataKey =
      unitPreference === "METRIC" ? "default_metric" : "default_imperial";

    let formatterMeta;
    if (overridenDisplayUnit) {
      formatterMeta = conversionFormulas[measureType].transformations.filter(
        (transformation) => transformation.id === overridenDisplayUnit
      )[0];
    }

    if (!formatterMeta) {
      let formatterMetaId = conversionFormulas[measureType][formattingDataKey];
      formatterMeta = conversionFormulas[measureType].transformations.filter(
        (transformation) => transformation.id === formatterMetaId
      )[0];
    }

    let formatterFn = getFormatterFn(formatterMeta.formatter);

    if (alreadyConverted) {
      if (typeof formatterMeta.unit === "object") {
        return formatterFn(value, formatterMeta, fallbackUnits);
      }
      return value + " " + formatterMeta.unit;
    }

    return formatterFn(Number(value).toFixed(3), formatterMeta, fallbackUnits);
  } else {
    if (fallbackUnits === null) {
      return numbro(value).format({
        mantissa: 2,
        thousandSeparated: true,
      });
    } else {
      return (
        numbro(value).format({
          thousandSeparated: true,
          mantissa: 2,
        }) +
        " " +
        fallbackUnits
      );
    }
  }
};

let prefetchFormulasPromise = null;

const prefetchFormulas = () => {
  if (prefetchFormulasPromise && !conversionFormulas) {
    return prefetchFormulasPromise;
  } else {
    prefetchFormulasPromise = new Promise(function (resolve, reject) {
      if (conversionFormulas) {
        resolve(conversionFormulas);
      } else {
        setTimeout(function () {
          // conversionFormulas = UNIT_CONVERSIONS;
          resolve(conversionFormulas);
        }, 1);
      }
    }).finally(function () {
      prefetchFormulasPromise = null;
    });

    return prefetchFormulasPromise;
  }
};

const getPreferredUnit = (deviceSensor, preferredUnitSystem) => {
  let displayUnit = deviceSensor.display_unit;
  let measureType = deviceSensor.sensor.measure_type;

  if (displayUnit) {
    return displayUnit;
  }

  let formattingDataKey =
    preferredUnitSystem === "METRIC" ? "default_metric" : "default_imperial";

  if (typeof conversionFormulas[measureType] != "undefined") {
    let systemUnitId = conversionFormulas[measureType][formattingDataKey];

    let foundUnit = getPossibleUnits(measureType).filter(function (unit) {
      return unit.id === systemUnitId;
    });

    if (foundUnit.length) {
      return foundUnit[0];
    } else {
      return getPossibleUnits(measureType)[0];
    }
  } else {
    return measureType;
  }
};

const getPossibleUnits = (measureType) => {
  if (!(measureType in conversionFormulas)) {
    return [];
  }

  return conversionFormulas[measureType].transformations;
};

export default {
  getPossibleUnits,
  getPreferredUnit,
  prefetchFormulas,
  format,
  getConvertedValue,
};
